var _path, _path2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1595_2942)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8236 19.1494L15.013 17.9755C14.5681 17.8404 14.1785 17.5654 13.9022 17.1914C13.6258 16.8174 13.4773 16.3642 13.4788 15.8992V13.4785H6.52286V15.8992C6.52462 16.3644 6.3763 16.8179 6.09991 17.1922C5.82353 17.5664 5.43382 17.8416 4.98864 17.9768L1.17809 19.1507C1.07952 19.182 0.995343 19.2474 0.940681 19.3352C0.886019 19.423 0.864449 19.5274 0.879845 19.6297C0.895241 19.732 0.946594 19.8254 1.02468 19.8932C1.10277 19.961 1.20248 19.9988 1.3059 19.9997H18.6958C18.7999 19.9998 18.9006 19.9625 18.9796 19.8945C19.0585 19.8266 19.1105 19.7326 19.126 19.6296C19.1415 19.5266 19.1194 19.4215 19.0639 19.3333C19.0085 19.2452 18.9232 19.1799 18.8236 19.1494Z",
    fill: "url(#paint0_linear_1595_2942)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5908 3.18182C15.0338 2.19502 14.2193 1.37797 13.2343 0.817878C12.2492 0.257787 11.1306 -0.0243271 9.99777 0.00164429C8.26823 0.00164429 6.60954 0.688698 5.38658 1.91166C4.16362 3.13462 3.47656 4.79332 3.47656 6.52285V7.39234C3.47656 11.7398 6.51979 15.6525 9.99777 15.6525C13.3692 15.6525 16.3233 11.9733 16.5016 7.39234H16.519V6.52285C16.5188 5.34554 16.1979 4.19051 15.5908 3.18182Z",
    fill: "url(#paint1_linear_1595_2942)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -9.82812,
    y: -7.65039,
    width: 39.6504,
    height: 31.3906
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_1_1595_2942_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1595_2942)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8228 10.4361V5.65385C17.8228 5.30794 17.6854 4.97621 17.4408 4.73161C17.1962 4.48702 16.8644 4.34961 16.5185 4.34961H3.47612C3.13021 4.34961 2.79847 4.48702 2.55388 4.73161C2.30929 4.97621 2.17188 5.30794 2.17188 5.65385V10.4361C2.17188 10.782 2.30929 11.1137 2.55388 11.3583C2.79847 11.6029 3.13021 11.7403 3.47612 11.7403H7.58273C7.65647 11.7403 7.72899 11.7216 7.79349 11.6858C7.85798 11.6501 7.91232 11.5985 7.9514 11.536L8.74481 10.2661C8.87778 10.0539 9.06247 9.87899 9.28155 9.75774C9.50063 9.63649 9.74692 9.57288 9.99732 9.57288C10.2477 9.57288 10.494 9.63649 10.7131 9.75774C10.9322 9.87899 11.1169 10.0539 11.2498 10.2661L12.0432 11.536C12.0823 11.5985 12.1367 11.6501 12.2012 11.6858C12.2656 11.7216 12.3382 11.7403 12.4119 11.7403H16.5185C16.8644 11.7403 17.1962 11.6029 17.4408 11.3583C17.6854 11.1137 17.8228 10.782 17.8228 10.4361Z",
    fill: "url(#paint2_linear_1595_2942)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47656 4.84961H16.5186C16.7317 4.84962 16.9361 4.9343 17.0869 5.08496C17.2377 5.23579 17.3232 5.441 17.3232 5.6543V10.4365C17.3231 10.6497 17.2376 10.8542 17.0869 11.0049C16.9361 11.1556 16.7317 11.2402 16.5186 11.2402H12.4473L11.6738 10.001C11.4959 9.71703 11.2483 9.48258 10.9551 9.32031C10.6619 9.15808 10.3321 9.07324 9.99707 9.07324C9.66206 9.07328 9.33218 9.15809 9.03906 9.32031C8.74601 9.48257 8.49917 9.71713 8.32129 10.001H8.32031L7.54688 11.2402H3.47656C3.26326 11.2402 3.05805 11.1557 2.90723 11.0049C2.75653 10.8542 2.672 10.6496 2.67188 10.4365V5.6543C2.67188 5.441 2.7564 5.23579 2.90723 5.08496C3.05805 4.93414 3.26326 4.84961 3.47656 4.84961Z",
    stroke: "url(#paint3_linear_1595_2942)",
    strokeOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1595_2942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2124 7.39293H4.7785C4.66319 7.39293 4.55262 7.34713 4.47108 7.2656C4.38955 7.18407 4.34375 7.07349 4.34375 6.95818C4.34375 6.84288 4.38955 6.7323 4.47108 6.65077C4.55262 6.56924 4.66319 6.52344 4.7785 6.52344H15.2124C15.3277 6.52344 15.4383 6.56924 15.5198 6.65077C15.6014 6.7323 15.6472 6.84288 15.6472 6.95818C15.6472 7.07349 15.6014 7.18407 15.5198 7.2656C15.4383 7.34713 15.3277 7.39293 15.2124 7.39293Z",
    fill: "white",
    fillOpacity: 0.16
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1595_2942",
    x: -9.82812,
    y: -7.65039,
    width: 39.6504,
    height: 31.3906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1595_2942"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_1595_2942_clip_path",
    transform: "translate(9.82812 7.65039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8228 10.4361V5.65385C17.8228 5.30794 17.6854 4.97621 17.4408 4.73161C17.1962 4.48702 16.8644 4.34961 16.5185 4.34961H3.47612C3.13021 4.34961 2.79847 4.48702 2.55388 4.73161C2.30929 4.97621 2.17188 5.30794 2.17188 5.65385V10.4361C2.17188 10.782 2.30929 11.1137 2.55388 11.3583C2.79847 11.6029 3.13021 11.7403 3.47612 11.7403H7.58273C7.65647 11.7403 7.72899 11.7216 7.79349 11.6858C7.85798 11.6501 7.91232 11.5985 7.9514 11.536L8.74481 10.2661C8.87778 10.0539 9.06247 9.87899 9.28155 9.75774C9.50063 9.63649 9.74692 9.57288 9.99732 9.57288C10.2477 9.57288 10.494 9.63649 10.7131 9.75774C10.9322 9.87899 11.1169 10.0539 11.2498 10.2661L12.0432 11.536C12.0823 11.5985 12.1367 11.6501 12.2012 11.6858C12.2656 11.7216 12.3382 11.7403 12.4119 11.7403H16.5185C16.8644 11.7403 17.1962 11.6029 17.4408 11.3583C17.6854 11.1137 17.8228 10.782 17.8228 10.4361Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1595_2942",
    x: 4.34375,
    y: 6.52344,
    width: 11.3027,
    height: 2.86963,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1595_2942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1595_2942",
    x1: 0.875,
    y1: 13.4785,
    x2: 16.0823,
    y2: 24.2884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCFF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1595_2942",
    x1: 3.47656,
    y1: 0,
    x2: 19.13,
    y2: 3.31189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCFF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1595_2942",
    x1: 2.17188,
    y1: 4.34961,
    x2: 17.3953,
    y2: 12.5354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1595_2942",
    x1: 2.66097,
    y1: 4.68555,
    x2: 17.8228,
    y2: 4.68555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1595_2942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM04);
export default __webpack_public_path__ + "static/media/m_04.7da2a2ad864d7bf7c925dc9f88cfa7d9.svg";
export { ForwardRef as ReactComponent };